module.exports = __webpack_public_path__ + "img/7-4.d1cec599.png";